import { Component, effect, inject, OnDestroy } from '@angular/core';
import { NonNullableFormBuilder, ReactiveFormsModule } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { FormValidators } from '@corelabs/angular/forms';
import { ButtonModule } from 'primeng/button';
import { FormInputComponent } from '@shared/forms';
import { QuizFacade } from '@app/store/quiz';
import { ItemSelectionService } from '../item-selection.service';

@Component({
    selector: 'app-create-quiz',
    templateUrl: './create-quiz.component.html',
    styleUrls: ['./create-quiz.component.css'],
    imports: [ReactiveFormsModule, TranslateModule, RouterLink, ButtonModule, FormInputComponent],
})
export class CreateQuizComponent implements OnDestroy {
    private readonly router = inject(Router);
    private readonly quizFacade = inject(QuizFacade);
    private readonly formBuilder = inject(NonNullableFormBuilder);
    private readonly itemSelectionService = inject(ItemSelectionService);

    readonly saving = this.quizFacade.saving;

    readonly form = this.formBuilder.group({
        name: this.formBuilder.control('', [FormValidators.Required, FormValidators.Text]),
    });

    constructor() {
        effect(() => {
            const createdId = this.quizFacade.createdId();
            if (this.quizFacade.saved() && createdId) {
                this.itemSelectionService.select({ id: createdId, type: 'quiz' });
                this.close();
            }
        });

        effect(() => {
            if (this.quizFacade.saving() === false && this.quizFacade.saved() === false) {
                this.form.enable();
            }
        });
    }

    ngOnDestroy(): void {
        this.quizFacade.clear();
    }

    onSubmit(): void {
        this.form.markAllAsTouched();

        if (this.form.valid) {
            this.form.disable();
            const value = this.form.getRawValue();
            this.quizFacade.createQuiz({
                name: value.name,
            });
        }
    }

    close(): void {
        this.router.navigate([{ outlets: { dialog: null } }]);
    }
}
